
import { MapLocation } from '@/types/location';

// Yellow Line Gaming Center Locations
export const yellowLineGamingCenters: MapLocation[] = [
  {
    id: 50001,
    name: "Yellow Line Gaming - Jeddah (Al Hamra)",
    type: "Game Center",
    devices: 2,
    coordinates: [21.53570176754014, 39.17717633558235],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
